<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? 'Expandir' : 'Recolher' }}</span>
                </li>


                <li @mouseover="showCadastrosMenu = true" @mouseleave="showCadastrosMenu = false">
                    <img src="@/assets/icons/menuCadastros.svg" />
                    <span>Cadastros</span>
                    <div v-if="showCadastrosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('UsuariosAdminTabPage', 'ADMINISTRADORES ESTABELECIMENTOS')">
                                <span>Usuários Administradores</span>
                            </li>
                            <li @click="selectOption('UsuariosSupervisoresTabPage', 'SUPERVISORES')">
                                <span>Usuários Supervisores</span>
                            </li>
                            <li @click="selectOption('UsuariosInspetoresTabPage', 'INSPETORES')">
                                <span>Usuários Inspetores</span>
                            </li>
                            <li @click="selectOption('UsuariosRtTabPage', 'RESPONSÁVEIS TÉCNICOS')">
                                <span>Usuários RTs</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @mouseover="showPocGestao = true" @mouseleave="showPocGestao = false">
                    <img src="@/assets/icons/menuTable.svg" />
                    <span>Acompanhamentos</span>
                    <div v-if="showPocGestao" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('GestaoProcessosMunicipioView_67', '')">
                                <span>67 Gerenciamento dos processos por município, registro de estabelecimentos, produtos e rótulos no departamento de inspeção</span>
                            </li>
                            <li @click="selectOption('GestaoProcessosMunicipioAbasView_67', '')">
                                <span>67 Gerenciamento dos processos por município, registro de estabelecimentos, produtos e rótulos no departamento de inspeção [ABAS]</span>
                            </li>
                            <li @click="selectOption('AnaliseGraficaDocumentos_70', '')">
                                <span>70 Análise Gráfica em documentos e projetos</span>
                            </li>
                            <li @click="selectOption('HistoricoAcessos_71', '')">
                                <span>71 Histórico de ações e acessos ao processo</span>
                            </li>
                            <li @click="selectOption('GestaoPesquisaProcessos_72', '')">
                                <span>72 Pesquisa em processos usando qualquer informação ou data</span>
                            </li>
                            <li @click="selectOption('ProcessoWorkflow_76', '')">
                                <span>75 Fluxo de trabalho (workflow) com etapas para os processos (MODELO OPERACIONAL)</span>
                            </li>
                            <li @click="selectOption('GestaoWorkflowProcessos_76', '')">
                                <span>75 Fluxo de trabalho (workflow) com etapas para os processos (GESTÃO)</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @mouseover="showRelatoriosMenu = true" @mouseleave="showRelatoriosMenu = false">
                    <img src="@/assets/icons/menuPrinter.png" />
                    <span>Relatórios</span>
                    <div v-if="showRelatoriosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul><li @click="selectOption('ColetaNCAnaliticoReportPage', 'RELATÓRIO: NÃO CONFORMIDADES DE COLETAS')">
                            <span>Coletas - Não Conformidades</span>
                        </li></ul>
                        
                        <ul><li @click="selectOption('EstabelecimentosReportPage', 'RELATÓRIO: ESTABELECIMENTOS')">
                            <span>Estabelecimentos</span>
                        </li></ul>
                        
                        <ul><li @click="selectOption('CapacidadeProducaoReportPage', 'RELATÓRIO: CAPACIDADE DE PRODUÇÃO')">
                            <span>Estabelecimentos - Capacidade de Produção</span>
                        </li></ul>

                        <ul><li @click="selectOption('EstebelecimentosParecerReportPage', 'RELATÓRIO: PARECER ESTABELECIMENTOS')">
                            <span>Estabelecimentos - Parecer Analítico</span>
                        </li></ul>

                        <ul><li @click="selectOption('MapaEstatisticoReportPage', 'RELATÓRIO: MAPA ESTATÍSTICO')">
                            <span>Mapa Estatístico</span>
                        </li></ul>

                        <ul><li @click="selectOption('NCAnaliticoReportPage', 'RELATÓRIO: ANALÍTICO DE NÃO CONFORMIDADES')">
                            <span>Não Conformidades - Analítico</span>
                        </li></ul>

                        <ul><li @click="selectOption('RastreabilidadeReportPage', 'RELATÓRIO: RASTREABILIDADE')">
                            <span>Rastreabilidade</span>
                        </li></ul>
                    </div>
                </li>


                <li @mouseover="showPocCadastros = true" @mouseleave="showPocCadastros = false">
                    <img src="@/assets/icons/menuOpcoes.svg" />
                    <span>Cadastros Avançados</span>
                    <div v-if="showPocCadastros" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('RelatorioAtividadeModeloForm_10', '')">
                                <span>10 Cadastro de Relatório de Atividades e Relatório de Atividades Complementar</span>
                            </li>
                            <li @click="selectOption('RelatorioAtividadeExecucaoForm_10', '')">
                                <span>10 Cadastro de Relatório (preenchimento)</span>
                            </li>
                            <li @click="selectOption('ElementosControleForm_11', '')">
                                <span>11 Cadastro de elementos de controle/inspeção</span>
                            </li>
                            <li @click="selectOption('AreaInspecaoForm_12', '')">
                                <span>12 Cadastro de áreas de inspeção(AI)</span>
                            </li>
                            <li @click="selectOption('UnidadeInspecaoForm_13', '')">
                                <span>13 Cadastro das UI (Unidades de Inspeção) por área/estabelecimento</span>
                            </li>
                            <li @click="selectOption('ItensProcessoForm_14', '')">
                                <span>14 Cadastro de Itens de Processo - checklist de Registro de Estabelecimentos no SIM</span>
                            </li>
                            <li @click="selectOption('PacEstabelecimentoForm_16', '')">
                                <span>16 Cadastro dos Programas de Autocontroles do estabelecimento</span>
                            </li>
                            <li @click="selectOption('RotulosForm_18', '')">
                                <span>18 Cadastro e de rótulos - processos, registros, alterações, cancelamentos, etc</span>
                            </li>
                            <li @click="selectOption('InformacoesAmbientaisForm_21', '')">
                                <span>21 Cadastro de informações ambientais</span>
                            </li>
                            <li @click="selectOption('ProcessosAberturaForm_24', '')">
                                <span>24 Protocolo de registro de processos - abertura</span>
                            </li>
                            <li @click="selectOption('ProcessosMovimentacaoForm_24', '')">
                                <span>24 Protocolo de registro de processos - movimentação</span>
                            </li>
                            <li @click="selectOption('ProcessosLista_24', '')">
                                <span>24 Protocolo de registro de processos - lista</span>
                            </li>
                        </ul>
                    </div>
                </li>                
                
                
                <li @mouseover="showPocOperacionaisI = true" @mouseleave="showPocOperacionaisI = false">
                    <img src="@/assets/icons/menuFolder.svg" />
                    <span>Operacionais - I</span>
                    <div v-if="showPocOperacionaisI" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('RegistroEstabelecimentoPage_27', '')">
                                <span>27 Módulo de protocolo de registro de estabelecimentos</span>
                            </li>
                            <li @click="selectOption('ProdutoRotuloSolicitacaoPage_29', '')">
                                <span>29 Módulo de protocolo de solicitação/acompanhamento de registro de produtos e rótulos pelos estabelecimentos (automático e online)</span>
                            </li>
                            <li @click="selectOption('ProtocoloAutoInfracao_31', '')">
                                <span>31 Módulo de protocolo de registro de processos de auto-infração</span>
                            </li>
                            <li @click="selectOption('PocTodo', '')">
                                <span>37 Lançamento das medições de Lux (luminosidade)</span>
                            </li>
                            <li @click="selectOption('PocTodo', '')">
                                <span>38 Lançamento de Controles de Combate à Fraude Econômica (Aferição de Pesos e Controle de Formulação)</span>
                            </li>
                            <li @click="selectOption('AcompanhamentoAbates_44', '')">
                                <span>44 Gerenciamento dos acompanhamentos de abate (incluído itens 45 e 46)</span>
                            </li>
                            <li @click="selectOption('PocTodo', '')">
                                <span>48 Modalidade de Inspeção baseada em Risco Estimado associado aos estabelecimentos (conforme manual DIPOA de 2019 ou legislação e regras próprias)</span>
                            </li>
                            <li @click="selectOption('ClassificacaoRisco_49', '')">
                                <span>49 Cálculo e determinação da classificação de risco</span>
                            </li>
                            <li @click="selectOption('AgendaFiscalizacao_52', '')">
                                <span>52 Gestão e controle das inspeções e sinalização/alertas baseados na frequência estabelecida pela classificação de risco</span>
                            </li>
                            <li @click="selectOption('PocTodo', '')">
                                <span>53 Modalidade de Inspeção baseada em modelos de documentos</span>
                            </li>
                            <li @click="selectOption('PocTodo', '')">
                                <span>54 Modalidade de Inspeção baseada em evidências</span>
                            </li>
                            <li @click="selectOption('InspecaoSupervisaoEstabelecimento_56', '')">
                                <span>56 Inspeção de Supervisão [ESTABELECIMENTO]</span>
                            </li>
                            <li @click="selectOption('InspecaoSupervisaoEstabelecimento_56B', '')">
                                <span>56 Inspeção de Supervisão [ESTABELECIMENTO/B]</span>
                            </li>
                            <li @click="selectOption('InspecaoSupervisaoSim_56', '')">
                                <span>56 Inspeção de Supervisão [SIM]</span>
                            </li>
                            <li @click="selectOption('SupervisaoSisbiPoc_57', '')">
                                <span>57 Inspeção de Integração ao SISBI-POA</span>
                            </li>
                            <li @click="selectOption('Boletos_58', '')">
                                <span>58 Gerenciamento dos boletos de pagamento (multas, taxas, serviços...)</span>
                            </li>
                            <li @click="selectOption('ValidacaoPIN_60', '')">
                                <span>60 Assinatura eletrônica e PIN de validação em documentos</span>
                            </li>
                        </ul>
                    </div>
                </li>

                
                
                                
                
                
                <li @mouseover="showPocGestao = true" @mouseleave="showPocGestao = false">
                    <img src="@/assets/icons/menuManager.svg" />
                    <span>Gerenciamento</span>
                    <div v-if="showPocGestao" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('GestaoProcessosMunicipioView_67', '')">
                                <span>67 Gerenciamento dos processos por município, registro de estabelecimentos, produtos e rótulos no departamento de inspeção</span>
                            </li>
                            <li @click="selectOption('GestaoProcessosMunicipioAbasView_67', '')">
                                <span>67 Gerenciamento dos processos por município, registro de estabelecimentos, produtos e rótulos no departamento de inspeção [ABAS]</span>
                            </li>
                            <li @click="selectOption('AnaliseGraficaDocumentos_70', '')">
                                <span>70 Análise Gráfica em documentos e projetos</span>
                            </li>
                            <li @click="selectOption('HistoricoAcessos_71', '')">
                                <span>71 Histórico de ações e acessos ao processo</span>
                            </li>
                            <li @click="selectOption('GestaoPesquisaProcessos_72', '')">
                                <span>72 Pesquisa em processos usando qualquer informação ou data</span>
                            </li>
                            <li @click="selectOption('ProcessoWorkflow_76', '')">
                                <span>75 Fluxo de trabalho (workflow) com etapas para os processos (MODELO OPERACIONAL)</span>
                            </li>
                            <li @click="selectOption('GestaoWorkflowProcessos_76', '')">
                                <span>75 Fluxo de trabalho (workflow) com etapas para os processos (GESTÃO)</span>
                            </li>


                            
                            <li @click="selectOption('LogsAcessoUsuarios', '')">
                                <span>Histórico de LOG's</span>
                            </li>


                            <li @click="selectOption('LogsAnexo', '')">
                                <span>Histórico acesso protocolos</span>
                            </li>


                            
                        </ul>
                    </div>
                </li>


                <li @click="setComponenteAtivo('MapaEnderecosPage', 'MAPA')">
                    <img src="@/assets/icons/menuMap.svg" />
                    <span>Mapa Endereços</span>
                </li>
                <li @click="setComponenteAtivo('UsuarioViewPage', 'USUÁRIO')">
                    <img src="@/assets/icons/menuEditUser.png" />
                    <span>Usuário</span>
                </li>

                <li @click="setComponenteAtivo('Faqs_66', 'FAQs')">
                    <img src="@/assets/icons/menuHelp.svg" />
                    <span>Perguntas e Respoatas (FAQ's)</span>
                </li>
                
                <li class="logout" @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.svg" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>

        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo ? nmTitulo : 'GESTOR' }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ globalStore.nmusuario }}</div>
                        <div class="establishment-name">{{ globalStore.nmep }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='AnexosSupervisorListaPage'"><AnexosSupervisorListaPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='DriveGrupoTabPage'"><DriveGrupoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='DrivePastaTabPage'"><DrivePastaTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='DrivePastaTabPage-Publico'"><DrivePastaTabPage :ckPublica="'S'" @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstabelecimentosInspetorTabPage'"><EstabelecimentosInspetorTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ListaAtividadesPage'"><ListaAtividadesPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='Pla08TabPage'"><Pla08TabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage :idView=globalStore.idusuario @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else-if="nmComponenteAtivo=='AtividadesTabPage'"><AtividadesTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ContasEmailTabPage'"><ContasEmailTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EpEditPage'"><EpEditPage :idEdicao="globalStore.idep" @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EpRdTabPage'"><EpRdTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='FeriadosTabPage'"><FeriadosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='MapaEnderecosPage'"><MapaEnderecosPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='MunicipiosTabPage'"><MunicipiosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProdutosTabPage'"><ProdutosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProdutosMapaTabPage'"><ProdutosMapaTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='SimInspetorEditPage'"><SimInspetorEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='SimsSupervisorTabPage'"><SimsSupervisorTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='TpDocsTabPage'"><TpDocsTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='TpProducaoTabPage'"><TpProducaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosAdminTabPage'"><UsuariosAdminTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosInspetoresTabPage'"><UsuariosInspetoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosRtTabPage'"><UsuariosRtTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosSupervisoresTabPage'"><UsuariosSupervisoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='PlaExpedicaoTabPage'"><PlaExpedicaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaLeiteTabPage'"><PlaLeiteTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaMelTabPage'"><PlaMelTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaMpTabPage'"><PlaMpTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaProducaoTabPage'"><PlaProducaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='CapacidadeProducaoReportPage'"><CapacidadeProducaoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ColetaNCAnaliticoReportPage'"><ColetaNCAnaliticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstebelecimentosParecerReportPage'"><EstebelecimentosParecerReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstabelecimentosReportPage'"><EstabelecimentosReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='MapaEstatisticoReportPage'"><MapaEstatisticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='NCAnaliticoReportPage'"><NCAnaliticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='RastreabilidadeReportPage'"><RastreabilidadeReportPage @close="setComponenteAtivo(null, null)"/></div>



                    <div v-else-if="nmComponenteAtivo=='PocTodo'"><PocTodo @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='RelatorioAtividadeModeloForm_10'"><RelatorioAtividadeModeloForm_10 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='RelatorioAtividadeExecucaoForm_10'"><RelatorioAtividadeExecucaoForm_10 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ElementosControleForm_11'"><ElementosControleForm_11 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='AreaInspecaoForm_12'"><AreaInspecaoForm_12 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UnidadeInspecaoForm_13'"><UnidadeInspecaoForm_13 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ItensProcessoForm_14'"><ItensProcessoForm_14 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PacEstabelecimentoForm_16'"><PacEstabelecimentoForm_16 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='RotulosForm_18'"><RotulosForm_18 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='InformacoesAmbientaisForm_21'"><InformacoesAmbientaisForm_21 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProcessosAberturaForm_24'"><ProcessosAberturaForm_24 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProcessosMovimentacaoForm_24'"><ProcessosMovimentacaoForm_24 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProcessosLista_24'"><ProcessosLista_24 @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else-if="nmComponenteAtivo=='RegistroEstabelecimentoPage_27'"><RegistroEstabelecimentoPage_27 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProdutoRotuloSolicitacaoPage_29'"><ProdutoRotuloSolicitacaoPage_29 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProtocoloAutoInfracao_31'"><ProtocoloAutoInfracao_31 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='AcompanhamentoAbates_44'"><AcompanhamentoAbates_44 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='InspecaoSupervisaoEstabelecimento_56'"><InspecaoSupervisaoEstabelecimento_56 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='InspecaoSupervisaoEstabelecimento_56B'"><InspecaoSupervisaoEstabelecimento_56B @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='InspecaoSupervisaoSim_56'"><InspecaoSupervisaoSim_56 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='SupervisaoSisbiPoc_57'"><SupervisaoSisbiPoc_57 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='Boletos_58'"><Boletos_58 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ValidacaoPIN_60'"><ValidacaoPIN_60 @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else-if="nmComponenteAtivo=='Faqs_66'"><Faqs_66 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GestaoProcessosMunicipioView_67'"><GestaoProcessosMunicipioView_67 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GestaoProcessosMunicipioAbasView_67'"><GestaoProcessosMunicipioAbasView_67 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='AnaliseGraficaDocumentos_70'"><AnaliseGraficaDocumentos_70 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='HistoricoAcessos_71'"><HistoricoAcessos_71 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GestaoPesquisaProcessos_72'"><GestaoPesquisaProcessos_72 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProcessoWorkflow_76'"><ProcessoWorkflow_76 @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GestaoWorkflowProcessos_76'"><GestaoWorkflowProcessos_76 @close="setComponenteAtivo(null, null)"/></div>
                    
                    
                    
                    <div v-else-if="nmComponenteAtivo=='LogsAcessoUsuarios'"><LogsAcessoUsuarios @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='LogsAnexo'"><LogsAnexo @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else><ResumoGeralPage /></div>
                </slot>
            </div>
        </main>
    </div>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { jwtDecode } from 'jwt-decode';
import { globalStore } from '@/globals';
import { useRouter } from 'vue-router';

// POC
import LogsAcessoUsuarios from '@/views/poc/LogsAcessoUsuarios.vue';
import LogsAnexo from '@/views/poc/LogsAnexo.vue';


import PocTodo from '@/views/poc/PocTodo.vue';
import RelatorioAtividadeModeloForm_10 from '@/views/poc/cadastros/RelatorioAtividadeModeloForm_10.vue';
import RelatorioAtividadeExecucaoForm_10 from '@/views/poc/cadastros/RelatorioAtividadeExecucaoForm_10.vue';
import ElementosControleForm_11 from '@/views/poc/cadastros/ElementosControleForm_11.vue';
import AreaInspecaoForm_12 from '@/views/poc/cadastros/AreaInspecaoForm_12.vue';
import UnidadeInspecaoForm_13 from '@/views/poc/cadastros/UnidadeInspecaoForm_13.vue';
import ItensProcessoForm_14 from '@/views/poc/cadastros/ItensProcessoForm_14.vue';
import PacEstabelecimentoForm_16 from '@/views/poc/cadastros/PacEstabelecimentoForm_16.vue';
import RotulosForm_18 from '@/views/poc/cadastros/RotulosForm_18.vue';
import InformacoesAmbientaisForm_21 from '@/views/poc/cadastros/InformacoesAmbientaisForm_21.vue';
import ProcessosAberturaForm_24 from '@/views/poc/cadastros/ProcessosAberturaForm_24.vue';
import ProcessosMovimentacaoForm_24 from '@/views/poc/cadastros/ProcessosMovimentacaoForm_24.vue';
import ProcessosLista_24 from '@/views/poc/cadastros/ProcessosLista_24.vue';

import RegistroEstabelecimentoPage_27 from '@/views/poc/operacional/RegistroEstabelecimentoPage_27.vue';
import ProdutoRotuloSolicitacaoPage_29 from '@/views/poc/operacional/ProdutoRotuloSolicitacaoPage_29.vue';
import ProtocoloAutoInfracao_31 from '@/views/poc/operacional/ProtocoloAutoInfracao_31.vue';
import AcompanhamentoAbates_44 from '@/views/poc/operacional/AcompanhamentoAbates_44.vue';
import InspecaoSupervisaoEstabelecimento_56 from '@/views/poc/operacional/supervisao_estabelecimento_56/InspecaoSupervisaoEstabelecimento_56.vue';
import InspecaoSupervisaoEstabelecimento_56B from '@/views/poc/operacional/est56b/InspecaoSupervisaoEstabelecimento_56B.vue';
import InspecaoSupervisaoSim_56 from '@/views/poc/operacional/InspecaoSupervisaoSim_56.vue';
import SupervisaoSisbiPoc_57 from '@/views/poc/operacional/SupervisaoSisbiPoc_57.vue';
import Boletos_58 from '@/views/poc/operacional/Boletos_58.vue';
import ValidacaoPIN_60 from '@/views/poc/operacional/ValidacaoPIN_60.vue';

import Faqs_66 from '@/views/poc/faqs/Faqs_66.vue';
import GestaoProcessosMunicipioView_67 from '@/views/poc/gestao/GestaoProcessosMunicipioView_67.vue';
import GestaoProcessosMunicipioAbasView_67 from '@/views/poc/gestao/GestaoProcessosMunicipioAbasView_67.vue';
import AnaliseGraficaDocumentos_70 from '@/views/poc/gestao/AnaliseGraficaDocumentos_70.vue';
import HistoricoAcessos_71 from '@/views/poc/gestao/HistoricoAcessos_71.vue';
import GestaoPesquisaProcessos_72 from '@/views/poc/gestao/GestaoPesquisaProcessos_72.vue';
import ProcessoWorkflow_76 from '@/views/poc/gestao/ProcessoWorkflow_76.vue';
import GestaoWorkflowProcessos_76 from '@/views/poc/gestao/GestaoWorkflowProcessos_76.vue';


import AnexosSupervisorListaPage from '@/views/listas/AnexosSupervisorListaPage.vue';
import EstabelecimentosInspetorTabPage from '@/views/cadastros/tabelas/EstabelecimentosInspetorTabPage.vue';
import ListaAtividadesPage from '@/views/planilhas/tabelas/ListaAtividadesPage.vue';
import Pla08TabPage from '../../views/planilhas/tabelas/Pla08TabPage.vue';
import UsuarioViewPage from '@/views/cadastros/visualizacoes/UsuarioViewPage.vue';

// SUBMENU CADASTROS
import AtividadesTabPage from '@/views/cadastros/tabelas/AtividadesTabPage.vue';
import ContasEmailTabPage from '@/views/cadastros/tabelas/ContasEmailTabPage.vue';
import EpEditPage from '@/views/cadastros/formularios/EpEditPage.vue'
import EpRdTabPage from '@/views/cadastros/tabelas/EpRdTabPage.vue';
import FeriadosTabPage from '@/views/cadastros/tabelas/FeriadosTabPage.vue';
import MapaEnderecosPage from '@/views/dashboard/MapaEnderecosPage.vue';
import MunicipiosTabPage from '@/views/cadastros/tabelas/MunicipiosTabPage.vue';
import ProdutosTabPage from '@/views/cadastros/tabelas/ProdutosTabPage.vue';
import ProdutosMapaTabPage from '@/views/cadastros/tabelas/ProdutosMapaTabPage.vue';
import ResumoGeralPage from '../dashboards/ResumoGeralPage.vue';
import SimInspetorEditPage from '@/views/cadastros/associacoes/SimInspetorEditPage.vue';
import SimsSupervisorTabPage from '@/views/cadastros/tabelas/SimsSupervisorTabPage.vue';
import TpDocsTabPage from '@/views/cadastros/tabelas/TpDocsTabPage.vue';
import TpProducaoTabPage from '@/views/cadastros/tabelas/TpProducaoTabPage.vue';
import UsuariosAdminTabPage from '@/views/cadastros/tabelas/UsuariosAdminTabPage.vue';
import UsuariosInspetoresTabPage from '@/views/cadastros/tabelas/UsuariosInspetoresTabPage.vue';
import UsuariosRtTabPage from '@/views/cadastros/tabelas/UsuariosRtTabPage.vue';
import UsuariosSupervisoresTabPage from '@/views/cadastros/tabelas/UsuariosSupervisoresTabPage.vue';

// SUBMENU PLANILHAS
import PlaExpedicaoTabPage from '@/views/planilhas/tabelas/PlaExpedicaoTabPage.vue';
import PlaLeiteTabPage from '@/views/planilhas/tabelas/PlaLeiteTabPage.vue';
import PlaMelTabPage from '@/views/planilhas/tabelas/PlaMelTabPage.vue';
import PlaMpTabPage from '@/views/planilhas/tabelas/PlaMpTabPage.vue';
import PlaProducaoTabPage from '@/views/planilhas/tabelas/PlaProducaoTabPage.vue';

// SUBMENU RELATÓRIOS
import CapacidadeProducaoReportPage from '@/views/reports/CapacidadeProducaoReportPage.vue';
import ColetaNCAnaliticoReportPage from '../reports/ColetaNCAnaliticoReportPage.vue';
import EstebelecimentosParecerReportPage from '../reports/EstebelecimentosParecerReportPage.vue';
import EstabelecimentosReportPage from '@/views/reports/EstabelecimentosReportPage.vue';
import MapaEstatisticoReportPage from '../reports/MapaEstatisticoReportPage.vue';
import NCAnaliticoReportPage from '../reports/NCAnaliticoReportPage.vue';
import RastreabilidadeReportPage from '@/views/reports/RastreabilidadeReportPage.vue';

// SUBMENU UTILITÁRIOS
import DriveGrupoTabPage from '@/views/utils/drive/DriveGrupoTabPage.vue';
import DrivePastaTabPage from '@/views/utils/drive/DrivePastaTabPage.vue';

const isCollapsed = ref(true);
const nmComponenteAtivo = ref(null);
const nmTitulo = ref(null);
const router = useRouter();
const showCadastrosMenu = ref(false);
const showPlanilhasMenu = ref(false);
const showRelatoriosMenu = ref(false);
const showUtilitariosMenu = ref(false);

const showPocCadastros = ref(false);
const showPocOperacionais = ref(false);
const showPocOperacionaisI = ref(false);
const showPocGestao = ref(false);

const timeRemaining = ref(null);
let timer = null;

const menuIcon = computed(() =>
  isCollapsed.value
    ? require('@/assets/icons/menuExpand.svg')
    : require('@/assets/icons/menuCollapse.svg')
);

const confirmLogout = () => {resetLogin();}

const resetLogin = () => {
    Api.loginAPI();
    router.push('/login');
}

const toggleMenu = () => { isCollapsed.value = !isCollapsed.value; }

const selectOption = (page, titulo) => {
    nmComponenteAtivo.value = page;
    nmTitulo.value = titulo;
    showCadastrosMenu.value = false;
    showPlanilhasMenu.value = false;
    showRelatoriosMenu.value = false;
    showUtilitariosMenu.value = false;

    showPocCadastros.value = false;
    showPocOperacionais.value = false;
    showPocOperacionaisI.value = false;
    showPocGestao.value = false;
}

const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}

const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
};

onMounted(() => {
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
});

onBeforeUnmount(() => {
    clearInterval(timer);
});
</script>